/**
 * Web Slider Component
 *
 */

import React from 'react'

import { SliderProvider } from './SliderProvider'
import { SliderInstance } from './SliderInstance'

import type { SliderAllProps } from './types'

export * from './types'

// Export the extensions
export { default as SliderMarker } from './SliderMarker'

function Slider(localProps: SliderAllProps) {
  return (
    <SliderProvider {...localProps}>
      <SliderInstance />
    </SliderProvider>
  )
}

Slider._formElement = true
Slider._supportsSpacingProps = true

export default Slider
